import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useAuth } from '../Context/AuthContext'

function ProtectedUserRoute({ component: Component, ...rest }) {
    const { loggedIn, currentUser } = useAuth();
    return (
        <Route {...rest} render={(props) => {
            return currentUser && loggedIn ? <Component /> : <Redirect to="/login" />
        }} />
    )
}

export default ProtectedUserRoute
